import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Layout } from './Layout'
import { StatsScreen } from './screens/Stats'
import { UsersScreen } from './screens/Users'
import { ProductsScreen } from './screens/Products'
import { PoliciesScreen } from './screens/Policies'
import { OrdersScreen } from './screens/Orders'
import { DictionariesScreen } from './screens/Dictionaries'
import { MenusScreen } from './screens/Menus'
import { AnnouncementsScreen } from './screens/Announcements'
import { PlatformConfigScreen } from './screens/PlatformConfig'
import { ChatScreen } from './screens/Chat'
import { AIChatScreen } from './screens/AIChat'
import { DataSyncScreen } from './screens/DataSync'
import { DataSyncZzshuScreen } from './screens/DataSyncZzshu'
import { DataSyncAibijiaScreen } from './screens/DataSyncAibijia'
import { LoginScreen } from './screens/Login'
import { ToastProvider } from './components/ui/Toast'
import { I18nProvider } from './lib/i18n'
import { bootstrapTheme } from './lib/theme'
import './index.css'

// Apply saved theme before React mounts so the first paint matches the user's
// preference instead of flashing the fallback.
bootstrapTheme()

const el = document.getElementById('root')
if (!el) throw new Error('#root not found')

createRoot(el).render(
  <I18nProvider>
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          {/* Standalone — no Layout/Sidebar/whoami probe. The user lands here
              after sign-out (?signed-out=1) or when they hit admin without a
              valid session. */}
          <Route path="/login" element={<LoginScreen/>}/>

          <Route element={<Layout/>}>
            <Route index path="/" element={<StatsScreen/>}/>
            <Route path="/users" element={<UsersScreen/>}/>
            <Route path="/products" element={<ProductsScreen/>}/>
            <Route path="/policies" element={<PoliciesScreen/>}/>
            <Route path="/orders" element={<OrdersScreen/>}/>
            <Route path="/dictionaries" element={<DictionariesScreen/>}/>
            <Route path="/menus" element={<MenusScreen/>}/>
            <Route path="/announcements" element={<AnnouncementsScreen/>}/>
            <Route path="/platform-config" element={<PlatformConfigScreen/>}/>
            <Route path="/chat" element={<ChatScreen/>}/>
            <Route path="/ai-chat" element={<AIChatScreen/>}/>
            <Route path="/data-sync" element={<DataSyncScreen/>}/>
            <Route path="/data-sync/zzshu" element={<DataSyncZzshuScreen/>}/>
            <Route path="/data-sync/aibijia" element={<DataSyncAibijiaScreen/>}/>
          </Route>
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  </I18nProvider>,
)
